import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Nav, NavItem } from "react-bootstrap";
import { HashLink as Link } from "react-router-hash-link";
import { IndexLinkContainer } from "react-router-bootstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from "react-accessible-accordion";

import {
  IoChevronBack,
  IoBusiness,
  IoIdCard,
  IoDocument,
  IoReader,
  IoBriefcase,
  IoLocation,
  IoReceipt,
  IoTime,
  IoTicket,
  IoServer
} from "react-icons/io5";

import MenuFooter from "./MenuFooter";

const navItems = (customer) => [
  {
    to: `/app/customers/${customer._id}#info`,
    name: "Info",
    icon: <IoBusiness size={15} />
  },
  {
    to: `/app/customers/${customer._id}/calls`,
    name: "Calls",
    icon: <IoTime size={15} />
  },
  {
    to: `/app/customers/${customer._id}#contracts`,
    name: "Contracts",
    icon: <IoReader size={15} />
  },
  {
    to: `/app/customers/${customer._id}#projects`,
    name: "Projects",
    icon: <IoBriefcase size={15} />
  },
  {
    to: `/app/customers/${customer._id}#tickets`,
    name: "Support Tickets",
    icon: <IoTicket size={15} />
  },
  {
    to: `/app/customers/${customer._id}#locations`,
    name: "Locations",
    icon: <IoLocation size={15} />
  },
  {
    to: `/app/customers/${customer._id}#contacts`,
    name: "Contacts",
    icon: <IoIdCard size={15} />
  },
  {
    to: `/app/customers/${customer._id}#expenses`,
    name: "Expenses",
    icon: <IoReceipt size={15} />
  },
  {
    to: `/app/customers/${customer._id}#notes`,
    name: "Notes",
    icon: <IoDocument size={15} />
  }
];
const scrollWithOffset = (el, offset) => {
  const elementPosition = el.offsetTop - offset;
  window.scroll({
    top: elementPosition,
    left: 0,
    behavior: "smooth"
  });
};
const CustomerMenu = ({ customer, onClickMenu }) => (
  <Nav className="sidebar sidebar-nav">
    <IndexLinkContainer to="/app/customers">
      <NavItem eventKey={1} onClick={onClickMenu}>
        <IoChevronBack size={16} />
        All Customers
      </NavItem>
    </IndexLinkContainer>
    {navItems(customer).map((item, i) => (
      <NavItem key={i} eventKey={i} onClick={onClickMenu}>
        <Link to={item.to} smooth scroll={(el) => scrollWithOffset(el, 75)}>
          {item.icon}
          <span>{item.name}</span>
        </Link>
      </NavItem>
    ))}
    <Accordion>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            <IoServer size={15} />
            <span>ITGlue</span>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <IndexLinkContainer
            to={`/app/customers/${customer._id}/itglue/Configurations`}
          >
            <NavItem onClick={onClickMenu}>Configurations</NavItem>
          </IndexLinkContainer>
          <IndexLinkContainer
            to={`/app/customers/${customer._id}/itglue/Licensing`}
          >
            <NavItem onClick={onClickMenu}>Licensing</NavItem>
          </IndexLinkContainer>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
    <MenuFooter />
  </Nav>
);

CustomerMenu.propTypes = {
  customer: PropTypes.object,
  onClickMenu: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    state,
    customer: state.reducers.customer
  };
}

export default connect(mapStatesToProps)(CustomerMenu);
